import React from "react";
import { useSelector } from "react-redux";
import BulkUploadListFilters from "../components/BulkUploadListFilters";
import TopBar from "../../../components/TopBar";
import BulkUploadTable from "../components/BulkUploadTable";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import { Stack } from "@mui/material";
import FeatureNotSupportedDialog from "../../common/FeatureNotSupportedDialog";
import useBulkUploadFilters from "../../../components/filters/BulkUploadFilterHelper";

function BulkUploadListPage({ category = "E_INVOICE", subCategory = null }) {
  useDocumentTitle("Bulk Upload List");
  const subscription = useSelector((state) => state.subscription.subscription);
  const isBulkUploadFeatureEnabled = subscription?.features?.enable_bulk_upload;
  const isSftpFeatureEnabled = subscription?.features?.enable_sftp;

  const {
    searchTerm,
    selectedFilter,
    selectedStatus,
    selectedCategory,
    currentQuery,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handleDateRangeChange,
    handlePaginationChange,
    handleStatusChange,
    handleCategoryChange
  } = useBulkUploadFilters();

  const filters = [
    {
      type: "search",
      options: [
        {
          key: "filename",
          placeholder: "File Name",
        },

      ],
    },
  ];

  return isBulkUploadFeatureEnabled || isSftpFeatureEnabled ? (
    <Stack direction="column" sx={{ mt: "-1rem" }}>
      <TopBar title={"Bulk Upload"}></TopBar>
      <BulkUploadListFilters
        filters={filters}
        selectedFilter={selectedFilter}
        selectedStatus={selectedStatus}
        selectedCategory ={selectedCategory}
        onFilterChange={handleFilterChange}
        searchTerm={searchTerm}
        onSearchChange={handleSearchChange}
        onSearchKeyPress={handleSearchKeyPress}
        onDateRangeChange={handleDateRangeChange}
        onStatusChange={handleStatusChange}
        onCategoryChange={handleCategoryChange}
      />
      <BulkUploadTable
        handlePaginationChange={handlePaginationChange}
        searchQuery={{ ...currentQuery}}
      />
    </Stack>
  ) : (
    !isBulkUploadFeatureEnabled && !isSftpFeatureEnabled && (
      <FeatureNotSupportedDialog
        title={"Bulk Upload"}
        description={
          "Upload and process multiple documents simultaneously, saving time and streamlining your workflow."
        }
      />
    )
  );
}

export default BulkUploadListPage;
